declare namespace $ {

	export class $bog_builderui_menu extends $bog_builderui_card {
		items( ): readonly(any)[]
		sub( ): ReturnType< $bog_builderui_menu['items'] >
	}
	
	export class $bog_builderui_menu_item extends $mol_button_minor {
	}
	
}

//# sourceMappingURL=menu.view.tree.d.ts.map